import React from 'react';
import { AdminCenterStyles } from './style';

function AdminCenterLayout({ children }) {
  return (
    <AdminCenterStyles>
      <div className="admin-center-content">{children}</div>
    </AdminCenterStyles>
  );
}

export default AdminCenterLayout;
